
import axiosInstance from './axiosInstance';

export default {
	install(Vue, options){

			Vue.prototype.$axios = axiosInstance
		}
};